import { render, staticRenderFns } from "./Leader.vue?vue&type=template&id=4785390e&"
import script from "./Leader.vue?vue&type=script&lang=js&"
export * from "./Leader.vue?vue&type=script&lang=js&"
import style0 from "./Leader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports